export const useData = (hook: any, mocks: Record<string, any>[], params: any, skip?: any) => {
    const useMocks = process.env.REACT_APP_USE_MOCKS === "true";
    const { data, isLoading, isFetching, error, refetch } = hook(params, { skip: useMocks || skip });

    return useMocks
        ? { data: mocks, isLoading: false, error: undefined, refetch: () => { } }
        : { data, isLoading, isFetching, error, refetch };
};

export const useLazyData = <
    TArgs = any,
    TData = any,
    TResult extends {
        data?: TData;
        isLoading: boolean;
        isFetching: boolean;
        error?: unknown;
    } = {
        data?: TData;
        isLoading: boolean;
        isFetching: boolean;
        error?: unknown;
    }
>(
    lazyHook: () => [(args: TArgs) => void, TResult, any],
    mocks: TData[]
) => {
    const useMocks = process.env.REACT_APP_USE_MOCKS === "true";

    // викликаємо сам хук
    const [trigger, result] = lazyHook(); // третій елемент ігноруємо

    const triggerSafe = (args: Parameters<typeof trigger>[0]) => {
        if (!useMocks) {
            trigger(args);
        }
    };

    return useMocks
        ? {
            trigger: () => {},
            data: mocks,
            isLoading: false,
            isFetching: false,
            error: undefined
        }
        : {
            trigger: triggerSafe,
            ...result
        };
};